<script setup>
const { isOnlyRequireLogin, isDisabled } = defineProps({
  isDisabled: {
    type: Boolean,
    default() {
      return false;
    },
  },
  isOnlyRequireLogin: {
    type: Boolean,
    default() {
      return true;
    },
  },
});
const emits = defineEmits(["onCallback"]);

const { status, getSession, data: sessionData } = useAuth();

const step = ref(1);
const profileDialogVisible = ref(false);
const authDialogVisible = ref(false);
const authForm = ref("signin");

const isLoading = ref(false);

const isAuthenticated = computed(() => {
  return status.value === "authenticated";
});

const handleCompleteProfile = (event) => {
  if (isDisabled) return;

  if (status.value !== "authenticated") {
    authDialogVisible.value = true;
    // navigateTo("/signin");
  } else if (
    !isOnlyRequireLogin &&
    !sessionData?.value?.data?.student_profile_completed
  ) {
    profileDialogVisible.value = true;
  }
};

const onUpdateInfo = async () => {
  if (
    sessionData?.value?.data?.agent_profile?.student_academic_completion_step
  ) {
    onClose();
    await useApiFetch("profile/complete", {
      method: "POST",
      async onResponse() {
        isLoading.value = true;
        await getSession();
        isLoading.value = false;
        if (sessionData?.value?.data?.student_profile_completed)
          emits("onCallback");
      },
    });
  } else {
    step.value = 2;
  }
};

const onUpdateAcademic = async () => {
  onClose();
  await useApiFetch("profile/complete", {
    method: "POST",
    async onResponse() {
      isLoading.value = true;
      await getSession();
      isLoading.value = false;
      if (sessionData?.value?.data?.student_profile_completed)
        emits("onCallback");
      step.value = 1;
    },
  });
};

const onClose = async () => {
  profileDialogVisible.value = false;
  await getSession();
};

const handleAuthOnClose = async () => {
  isLoading.value = true;
  authDialogVisible.value = false;
  await getSession();

  isLoading.value = false;

  if (isAuthenticated.value) emits("onCallback");
};

onMounted(() => {
  if (!sessionData?.value?.data?.student_profile_completed) {
    step.value = sessionData?.value?.data?.profile?.completion_step || 1;
  }
});
</script>

<template>
  <FullscreenLoading :loading="isLoading" />
  <div>
    <!-- <p>{{ status }} - {{ isAuthenticated }}</p> -->
    <div
      v-if="
        !sessionData?.data?.student_profile_completed && !isOnlyRequireLogin
      "
      @click="handleCompleteProfile"
    >
      <slot />
    </div>
    <div @click="handleCompleteProfile" v-else>
      <slot />
    </div>
  </div>

  <Dialog
    v-model:visible="authDialogVisible"
    modal
    :showHeader="false"
    :style="{ width: '35rem', maxHeight: '96vh' }"
    class="m-2"
    minX="2"
    :pt="{
      content: 'p-4 lg:px-10 lg:pt-4 lg:pb-10 overflow-auto',
    }"
  >
    <div class="w-full h-full flex flex-col flex-1 space-y-4 pb-2">
      <template v-if="authForm === 'signin'">
        <div class="text-right">
          <Button
            icon="pi pi-times"
            text
            rounded
            @click="handleAuthOnClose"
          ></Button>
        </div>
        <h1
          class="text-2xl lg:text-3xl leading-[1.3] font-bold text-primary-500 mb-4 !mt-0"
        >
          Get Program Recommendations <br />
          Based on Your Profile ✨ 
        </h1>
        <SignInForm
          :isMini="true"
          @signup="authForm = 'signup'"
          @onClose="handleAuthOnClose"
        />
      </template>
      <template v-else>
        <div class="text-right">
          <Button
            icon="pi pi-times"
            text
            rounded
            @click="handleAuthOnClose"
          ></Button>
        </div>
        <h1
          class="text-2xl lg:text-3xl leading-[1.3] font-bold text-primary-500 mb-4 !mt-0"
        >
          Get Program Recommendations <br />
          Based on Your Profile ✨ 
        </h1>
        <SignUpForm
          :isMini="true"
          @signin="authForm = 'signin'"
          @onClose="handleAuthOnClose"
        />
      </template>
    </div>
  </Dialog>

  <Dialog
    v-model:visible="profileDialogVisible"
    modal
    header="Complete your profile"
    :style="{ width: '45rem', maxHeight: '96vh' }"
    :pt="{
      content: 'p-0 overflow-auto',
    }"
  >
    <div v-if="step === 1" class="px-8 py-5">
      <PersonalInfoRequiredForm @onClose="onClose" @onSave="onUpdateInfo" />
    </div>
    <AcademicForm v-else @onClose="onClose" @onSave="onUpdateAcademic" />
  </Dialog>
</template>
